module.exports = __webpack_public_path__ + "img/02935052d7a149f9bef184f3a210f433-1024.b481ae89.jpg";